
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CookieCiencuadras } from 'src/app/utils/cookie-ciencuadras/cookie-ciencuadras';
import { ProductsService } from '../../../services/products/products.service';
import { DataLayerService } from '../../../services/dataLayer/data-layer.service';

@Component({
  selector: 'app-confirm-telephone',
  templateUrl: './confirm-telephone.component.html',
  styleUrls: ['./confirm-telephone.component.scss']
})
export class ConfirmTelephoneComponent implements OnInit {

  phoneValidator: FormGroup;
  msgsPhoneError: any = {
    required: 'Debe ser númerico',
    max: 'Debe tener mínimo 7 números',
    min: 'Debe tener máximo 10 números',
    service: 'No se pudo actualizar los datos'
  };
  msgsCellPhoneError: any = {
    required: 'Debe ser númerico',
    max: 'Debe tener mínimo 10 números',
    min: 'Debe tener máximo 12 números',
    service: 'No se pudo actualizar los datos'
  };
  isFailUpdateInfo = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmTelephoneComponent>,
    private cookieCiencuadras: CookieCiencuadras,
    private productsService: ProductsService,
    private dataLayerService: DataLayerService
  ) { }

  get form() { return this.phoneValidator.controls; }

  ngOnInit(): void {
    this.phoneValidator = new FormGroup({
      phone: new FormControl('', [Validators.required, Validators.min(999999), Validators.max(9999999999)]),
      cellphone: new FormControl('', [Validators.required, Validators.min(999999999), Validators.max(999999999999)]),
    }); 
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async actualizateDate(){
    console.log('this.phoneValidator.value: ', this.phoneValidator.value);
    let value = this.phoneValidator.value;

    const phone = value.phone ? value.phone : value.cellphone;
    const cellPhone = value.cellphone ? value.cellphone : value.phone;
    
    console.log('value: ', value);
    console.log('phone: ', phone);
    console.log('cellPhone: ', cellPhone);
    
    if (this.phoneValidator.valid) {
      let user_id: string = this.cookieCiencuadras.getCookie('user_id') ? this.cookieCiencuadras.getCookie('user_id') : localStorage.getItem('currentUser');
      let updateUserInformation = await this.updateUserInformation(user_id, phone, cellPhone);
        
      if(updateUserInformation){
        this.dialogRef.close(true);

        this.dataLayerService.pushTagEventClick({
          'event':'ga_event',
          'category':'productos',
          'action':'CCW - confirmar telefono',
          'label':'CONFIRMAR'
        });
      }else{
        this.isFailUpdateInfo = true;
      }
    }else{
      this.isFailUpdateInfo = true;
    }
    
  }

  async updateUserInformation(user_id: string, phone: string, cellPhone: string){

    // TODO: Para pruebas:
    // {"status":true,"message":"User updated!"}
    // return true;
    // {"status":false,"message":"El tel\u00e9fono debe ser un campo num\u00e9rico"}
    // return false;

    return new Promise((resolve) => {
      this.productsService.updateUserInformation(
        user_id,
        phone,
        cellPhone
      ).pipe().subscribe(res => {
        console.log('------------------', res);
        if (res.status) {
          
          resolve(true);
        }
        resolve(false);
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log('An error occurred:', err.error.message);
        } else {
          console.log('Backend returned status code: ', err.status);
          console.log('Response body:', err.error);
        }
        resolve(false);
      });
    });
  }

}
